import _ from 'lodash'
import { PRODUCT_VOLUME, PRODUCT_VOLUME_MAP, FIELD_MAX_NUM_VAL } from '@vzmi/shp_shared_compo/constants/proposal'
import {
  formatAll,
  showOnlyNumber,
  showOnlyPositiveNumber,
  showLessThan,
  showRoundedNumber,
  showValidSizeDimension
} from '../../../../../lib/formatter'

/** 商品材積各欄位要輸出 "長 XX", "寬 XX", "高 XX" 的形式給畫面上的 input */
export const productSizeFieldsFormatter = (valueInStore, fullFieldName) => {
  const fieldName = _.last(fullFieldName.split('.'))
  if (_.includes(PRODUCT_VOLUME, fieldName)) {
    const dimensionNumber = showValidSizeDimension(valueInStore)
    if (dimensionNumber !== '') {
      const dimensionLabel = PRODUCT_VOLUME_MAP[fieldName]
      return `${dimensionLabel} ${dimensionNumber}`
    }
  }

  return ''
}

/** 最小包裝數 有特殊上限值 FIELD_MAX_NUM_VAL.MIN_PACKING_COUNT */
export const minPackingCountFormatter = formatAll(
  showOnlyNumber,
  showOnlyPositiveNumber,
  showRoundedNumber,
  showLessThan(FIELD_MAX_NUM_VAL.MIN_PACKING_COUNT)
)

/** 自訂商品屬性與自訂規格 字數長度限制 20個字 */
export const customAttributeInputLengthFormatter = valueInStore => {
  return _.toString(valueInStore).substr(0, 20)
}

export const idsFormatter = (valueInStore = []) => {
  const joinedValues = _.isArray(valueInStore)
    ? valueInStore.join(',')
    : ''

  return joinedValues
}
